import "./style.scss";

import { ExpanderLayout } from "@amzn/stencil-react-components/expander";
import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { Col } from "@amzn/stencil-react-components/layout";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useMemo } from "react";

import ExpanderQuestion from "../ExpanderQuestion/ExpanderQuestion";

const stringPath = "details.faq.licenseLimit";
const questionsCount = 7;

export interface LicenseLimitFlyoutProps {
  onClose: () => void;
}

export const LicenseLimitFlyout: FC<LicenseLimitFlyoutProps> = ({ onClose }) => {
  const faqData = useMemo(() => {
    const questions = [];
    for (let i = 1; i <= questionsCount; i++) {
      questions.push({
        id: i,
        title: `${stringPath}.question${i}`,
        content: `${stringPath}.answer${i}`,
      });
    }
    return questions;
  }, [questionsCount]);

  return (
    <FlyoutContent
      titleText={getString(`${stringPath}.title`)}
      onCloseButtonClick={onClose}
      dataTestId="license-limit-reached-faq-flyout"
    >
      <Col dataTestId="license-limit-reached-faq-list" gridGap="S300">
        {faqData.map((faq) => (
          <ExpanderQuestion
            title={getString(faq.title)}
            content={getString(faq.content)}
            layout={ExpanderLayout.Card}
            key={`license-limit-faq-item-${faq.id}`}
          />
        ))}
      </Col>
    </FlyoutContent>
  );
};
